<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <b-row class="match-height">
              <b-col cols="12">
                <tab-position :tabs="tabs" :name="'Land'" />
              </b-col>
            </b-row> -->
            <p class="text-muted font-13 mb-0"></p>
            <div>
              <good-table-column-search ref="driverTable" :moduleapi="`${this.baseApi}/driver`" title="Visit Assistant" :columns="columns"
                routerpath="/master/crm/adddriver" :formOptions="formOptions" :newPage="true" :edit="edit" :add="add"
                :canDelete="canDelete" :viewFields="viewFields">
              </good-table-column-search>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodTableColumnSearch from "../../../../components/GoodTableColumnSearch.vue";
import TabPosition from "../../../../components/TabView.vue";
const baseApi = process.env.VUE_APP_APIENDPOINT;
export default {
  components: {
    GoodTableColumnSearch,
    TabPosition,
  },
  data() {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      columns: [
        {
          label: "Username",
          field: "username",
          filterOptions: {
            enabled: true,
            placeholder: "Search Username",
          },
        },
        {
          label: "Name",
          field: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search name",
          },
        },
        {
          label: "Mobile No",
          field: "mobile",
          filterOptions: {
            enabled: true,
            placeholder: "Search Mobile No",
          },
        },
        {
          label: "Email",
          field: "email",
          filterOptions: {
            enabled: true,
            placeholder: "Search Email",
          },
        },
        {
          label: "Joining Date",
          field: "joiningdate",
          type: 'datetime',
          filterOptions: {
            enabled: true,
            placeholder: "Search Joining Date",
          },
        },
        {
          label: "Licence No",
          field: "licence",
          filterOptions: {
            enabled: true,
            placeholder: "Search Joining Date",
          },
        },
        {
          label: "Enter By",
          field: "enterby",
          type: "staticdropdown",
          responseValue: 'fullname',
          url: 'getUsers',
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Enter Date",
          field: "enterdatetime",
          type: "datetime",
          time: true,
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Modified By",
          field: "modifiedby",
          type: "staticdropdown",
          responseValue: 'fullname',
          url: 'getUsers',
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Modified Date",
          field: "modifieddatetime",
          time: true,
          type: "datetime",
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      formOptions: {
        submitRouterPath: "/master/crm/driver",
        formTitle: "Add Visit Assistant",
        gridForm: true,
        method: "post",
        action: "add",
        getEditValue: `${baseApi}/getusersbyid`,
        url: `${baseApi}/driver`,
        inputFields: [
          {
            label: "Password",
            name: "password",
            value: "",
            type: "password",
            placeholder: "Enter Password",
            class: "col-md-6",
            required: true,
          },
        ],
      },
      edit: "",
      add: "",
      canDelete: "",
      viewFields: [
        {
          label: "Profile Image",
          field: "profile_image",
          type: "image",
          class: "col-md-4",
        },
        {
          label: "Username",
          field: "username",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Name",
          field: "name",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Surname",
          field: "surname",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Father/Husband Name",
          field: "fathername",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Email",
          field: "email",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Mobile",
          field: "mobile",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Gender",
          field: "gender",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Birth Date",
          field: "birthdate",
          type: "date",
          class: "col-md-4",
        },
        {
          label: "Joining Date",
          field: "joiningdate",
          type: "date",
          class: "col-md-4",
        },
        {
          label: "Resign Date",
          field: "resigndate",
          type: "date",
          class: "col-md-4",
        },
        {
          label: "Marital Status",
          field: "maritalstatus",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Anniversary Date",
          field: "anniversarydate",
          type: "date",
          class: "col-md-4",
        },
        {
          label: "Current Address",
          type: "heading",
          class: "col-md-12",
        },
        {
          label: "Address Line 1",
          field: "curaddressline1",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Address Line 2",
          field: "curaddressline2",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Pin Code",
          field: "curpincode",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "City",
          field: "curcity",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Area",
          field: "curarea",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "State",
          field: "curstate",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Permanent Address",
          type: "heading",
          class: "col-md-12",
        },
        {
          label: "Address Line 1",
          field: "peraddressline1",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Address Line 2",
          field: "peraddressline2",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Pin Code",
          field: "perpincode",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "City",
          field: "percity",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Area",
          field: "perarea",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "State",
          field: "perstate",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Bank Details",
          type: "heading",
          class: "col-md-12",
        },
        {
          label: "Bank Name",
          field: "bankname",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Branch",
          field: "bankbranch",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Account No",
          field: "bankaccno",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "IFSC Code",
          field: "ifsccode",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Documents",
          type: "heading",
          class: "col-md-12",
        },
        {
          label: "Aadhar Card No",
          field: "aadharcardno",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Aadhar Card Front Side",
          field: "aadharfrontside",
          type: "attachment",
          class: "col-md-4",
        },
        {
          label: "Aadhar Card Back Side",
          field: "aadharbackside",
          type: "attachment",
          class: "col-md-4",
        },
        {
          label: "PAN No",
          field: "panno",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Licence Details",
          type: "heading",
          class: "col-md-12",
        },
        {
          label: "Licence No",
          field: "licence",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Licence Issue Date",
          field: "licenceissuedate",
          type: "date",
          class: "col-md-4",
        },
        {
          label: "Licence Expiry Date",
          field: "licenceexpirydate",
          type: "date",
          class: "col-md-4",
        },
        {
          label: "Licence Photo",
          field: "licencephoto",
          type: "attachment",
          class: "col-md-4",
        },
        {
          label: "Other Details",
          type: "heading",
          class: "col-md-12",
        },
        {
          label: "Work Experience",
          field: "experience",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Education",
          field: "education",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Latest Marksheet/Degree",
          field: "marksheet",
          type: "attachment",
          class: "col-md-4",
        },
      ],
    };
  },
  mounted() {
    const userData = JSON.parse(localStorage.getItem("UserRights"));
    const role = JSON.parse(localStorage.getItem("userData")).role;
    if (role !== "admin") {
      userData.map((item) => {
        if (item.modulename == "Driver") {
          this.edit = item.edit;
          this.add = item.add;
          this.canDelete = item.delete;
          if (
            item.edit !== 1 &&
            item.add !== 1 &&
            item.delete !== 1 &&
            item.view !== 1
          ) {
            this.$router.push("/");
          }
        }
      });
    }
    
    // Override the getGridData method to include employees with Visit Assistant designation
    this.$nextTick(() => {
      if (this.$refs.driverTable) {
        this.originalGetGridData = this.$refs.driverTable.getGridData;
        this.$refs.driverTable.getGridData = this.getCombinedData;
        // Initial load
        this.getCombinedData();
      }
    });
  },
  watch: {
    // Watch for changes that might indicate new employees were added
    '$store.state.app.employee': {
      handler() {
        // Refresh data when employee store changes
        this.$nextTick(() => {
          this.refreshData();
        });
      },
      deep: true
    }
  },
  methods: {
    async getCombinedData() {
      try {
        // First, get the original driver data using the original method
        await this.originalGetGridData.call(this.$refs.driverTable);
        
        // Get additional employees with Visit Assistant designation
        const employeeData = await this.getVisitAssistantEmployees();
        
        // Get existing driver data from the table
        const existingData = this.$refs.driverTable.rows || [];
        
        // Filter out employees that are already in the driver table to avoid duplicates
        const existingUsernames = existingData.map(item => item.username);
        const newEmployees = employeeData.filter(emp => !existingUsernames.includes(emp.username));
        
        // Combine existing data with new employees
        const combinedData = [...existingData, ...newEmployees];
        
        // Update the table with combined data
        if (this.$refs.driverTable) {
          this.$refs.driverTable.rows = combinedData;
          this.$refs.driverTable.paginationTotal = combinedData.length;
          this.$refs.driverTable.loadData = false;
        }
      } catch (error) {
        console.error('Error fetching combined data:', error);
        if (this.$refs.driverTable) {
          this.$refs.driverTable.loadData = false;
        }
      }
    },
    
    
    async getVisitAssistantEmployees() {
      const accessToken = localStorage.getItem("accessToken");
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      
      // First, get all employees with Visit Assistant designation from /getEmployee
      const response = await fetch(`${this.baseApi}/getEmployee`, requestOptions);
      const json = await response.json();
      
      // Filter employees with Visit Assistant designation
      const visitAssistantEmployees = json.data?.filter(employee => 
        employee.position && employee.position.name === "Visit Assistant"
      ) || [];
      
      // Now fetch complete details for each employee using /getusersbyid
      const employeesWithCompleteData = await Promise.all(
        visitAssistantEmployees.map(async (employee) => {
          try {
            const detailResponse = await fetch(`${this.baseApi}/getusersbyid/${employee.id}`, requestOptions);
            const detailJson = await detailResponse.json();
            const completeData = detailJson.data?.[0] || employee;
            
            
            return {
              ...employee,
              ...completeData, // Merge with complete data
              // Ensure all required fields are present
              username: completeData.username || employee.username || '',
              fullname: completeData.fullname || employee.name || '',
              name: completeData.name || employee.name || '',
              mobile: completeData.mobile || '',
              email: completeData.email || '',
              joiningdate: completeData.joiningdate || employee.joiningdate || '',
              licence: completeData.licence || employee.licence || '',
              // Handle enterby field - it might be an object or string
              enterby: completeData.enterby_data && completeData.enterby_data[0] ? completeData.enterby_data[0] : completeData.enterby || employee.enterby || '',
              enterdatetime: completeData.enterdatetime || completeData.created_at || employee.enterdatetime || '',
              // Handle modifiedby field - it might be an object or string
              modifiedby: completeData.modifiedby_data && completeData.modifiedby_data[0] ? completeData.modifiedby_data[0] : completeData.modifiedby || employee.modifiedby || '',
              modifieddatetime: completeData.modifieddatetime || completeData.updated_at || employee.modifieddatetime || '',
              // Add a flag to identify this as an employee
              isEmployee: true,
              designation: employee.position?.name || ''
            };
          } catch (error) {
            console.error(`Error fetching details for employee ${employee.name}:`, error);
            // Return original employee data if detail fetch fails
            return {
              ...employee,
              username: employee.username || '',
              fullname: employee.name || '',
              name: employee.name || '',
              mobile: '',
              email: '',
              joiningdate: employee.joiningdate || '',
              licence: employee.licence || '',
              enterby: employee.enterby || '',
              enterdatetime: employee.enterdatetime || '',
              modifiedby: employee.modifiedby || '',
              modifieddatetime: employee.modifieddatetime || '',
              isEmployee: true,
              designation: employee.position?.name || ''
            };
          }
        })
      );
      
      
      return employeesWithCompleteData;
    },
    
    // Method to refresh data (can be called externally)
    refreshData() {
      this.getCombinedData();
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
